<template>
  <div class="container">
    <div class="container pR" v-if="$store.state.isPc">
      <div class="btn-more-box" @mouseenter="moreEnter" @mouseleave="moreLeave"
           @click="moreClick">
        <div class="btn-more flexHC2" :class="isHover ? 'btn-more-hover' : ''">
        </div>
        <div class="btn-more-text flexHC2" :class="isHover ? 'CFFF' : 'C000'">
          <span>了解更多</span>
          <img :src="isHover ? whiteArrow : arrow"
               style="width: 15px;height: 11px;margin-left: 5px;">
        </div>
      </div>
      <div class="left">
        <div style="width: 260px;height: 90px;" class="pR flexVC">
          <div class="title">五种时间</div>
          <div class="w100 pR title-line-box">
            <div class="titleLine"></div>
            <div class="titleLine-animation"
                 :class="currentIndex == 3 ? 'titleLine-animation-index' : '' "></div>
          </div>
        </div>
        <div class="content">{{content}}</div>
      </div>
      <div class="test-scroll  pR" id="scrollBox" @mousewheel="debounce"
           @DOMMouseScroll="debounceFirefox">
        <div class="right">
          <div class="flexHC" v-for="item in homeTime" style="height: 260px;margin-bottom: 14px;">
            <img
              class="cover"
              :src="item.coverUrl"></img>
            <div class="time-box">
              <img src="../../../assets/images/icon_home_time.png" class="floating-img">
              <div class="time-title">{{item.title}}</div>
              <div class="time-subtitle">{{item.subtitle}}</div>
              <div class="time-content">{{item.content}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-m pR flexVC2" v-if="!$store.state.isPc">
      <!--      <div style="height: 13.9%;"></div>-->
      <div style="width: 1.9rem;height: 0.6rem;" class="pR flexVC">
        <div class="title-m">五种时间</div>
        <div class="w100 pR title-line-box-m">
          <div class="titleLine-m"></div>
          <div class="titleLine-animation-m"
               :class="currentIndex == 3 ? 'titleLine-animation-index-m' : '' "></div>
        </div>
      </div>
      <div class="content-m" style="margin-top: 0.4rem;">{{content}}</div>
      <div class="btn-more-box-m flexHC2" @mouseenter="moreEnter" @mouseleave="moreLeave"
           @click="moreClick">
        <span>了解更多</span>
        <img :src="isHover ? arrow : arrow"
             style="width: 0.18rem;height: 0.16rem;margin-left: 5px;">
      </div>
      <div style="height: 1.2rem;"></div>
      <div class="w100m">
        <swiper :watchOverflow="true" :options="swiperOption"
                @slideChangeTransitionEnd="swiperChange">
          <swiper-slide>
            <!--          v-for="item in homeTime"-->
            <div class="w100m">
              <div class="flexHC home-item pR">
                <img src="../../../assets/images/icon_home_time.png" class="floating-img-m">
                <div class="w100m flexHC">
                  <img
                    class="cover-m"
                    :src="homeTimeM1.coverUrl"></img>
                  <div class="time-box-m ">
                    <div class="time-title-m">{{homeTimeM1.title}}</div>
                    <div class="time-subtitle-m">{{homeTimeM1.subtitle}}</div>
                    <div class="time-content-m fontE4">{{homeTimeM1.content}}</div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="w100m">
              <div class="flexHC home-item pR">
                <img src="../../../assets/images/icon_home_time.png" class="floating-img-m">
                <div class="w100m flexHC">
                  <img
                    class="cover-m"
                    :src="homeTimeM2.coverUrl"></img>
                  <div class="time-box-m ">
                    <div class="time-title-m">{{homeTimeM2.title}}</div>
                    <div class="time-subtitle-m">{{homeTimeM2.subtitle}}</div>
                    <div class="time-content-m fontE4">{{homeTimeM2.content}}</div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="w100m">
              <div class="flexHC home-item pR">
                <img src="../../../assets/images/icon_home_time.png" class="floating-img-m">
                <div class="w100m flexHC">
                  <img
                    class="cover-m"
                    :src="homeTimeM3.coverUrl"></img>
                  <div class="time-box-m ">
                    <div class="time-title-m">{{homeTimeM3.title}}</div>
                    <div class="time-subtitle-m">{{homeTimeM3.subtitle}}</div>
                    <div class="time-content-m fontE4">{{homeTimeM3.content}}</div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="w100m">
              <div class="flexHC home-item pR">
                <img src="../../../assets/images/icon_home_time.png" class="floating-img-m">
                <div class="w100m flexHC">
                  <img
                    class="cover-m"
                    :src="homeTimeM4.coverUrl"></img>
                  <div class="time-box-m ">
                    <div class="time-title-m">{{homeTimeM4.title}}</div>
                    <div class="time-subtitle-m">{{homeTimeM4.subtitle}}</div>
                    <div class="time-content-m fontE4">{{homeTimeM4.content}}</div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="w100m">
              <div class="flexHC home-item pR">
                <img src="../../../assets/images/icon_home_time.png" class="floating-img-m">
                <div class="w100m flexHC">
                  <img
                    class="cover-m"
                    :src="homeTimeM5.coverUrl"></img>
                  <div class="time-box-m ">
                    <div class="time-title-m">{{homeTimeM5.title}}</div>
                    <div class="time-subtitle-m">{{homeTimeM5.subtitle}}</div>
                    <div class="time-content-m fontE4">{{homeTimeM5.content}}</div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="w100m flexHC2" style="margin-top: 0.4rem;">
          <div class="w100m" v-for="(item,index) in pointArray"
               :class="index == activeIndex ? 'point-select' : 'point-default'"></div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

  import whiteArrow from '@/assets/images/icon_home_right_arrow_white.png'
  import arrow from '@/assets/images/icon_home_right_arrow.png'
  import {homeTime,homeTimeMobile} from '@/utils/staticData'
  import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

  export default {
    name: "HomeThird",
    props: ["currentIndex", 'lastIndex'],
    data() {
      return {
        content: '正向人生的五种时间是由趁早学院独创的个人认知和思考方法体系，是一种匹配时代与个人发展需求而产生的时间分类和管理方式，它完整而系统，可以帮你定位出此刻所在的位置，也可以让你展开方向明确的持续行动，让你获得更明晰、更认同自身价值也更坚定的生活',
        isHover: false,
        whiteArrow: whiteArrow,
        homeTimeMobile: homeTimeMobile,
        arrow: arrow,
        cover: 'cover',
        homeTime: [],
        homeTimeM1: {},
        homeTimeM2: {},
        homeTimeM3: {},
        homeTimeM4: {},
        homeTimeM5: {},
        pointArray: 5,
        activeIndex: 1,
        swiperOption: {
          parallax: true,
          initialSlide: 1,
          slidesPerView: 2,
          centeredSlides: true,
          spaceBetween: 230,
          grabCursor: true,
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true
          },
          pagination: {
            el: '.swiper-pagination',
            bulletClass: 'my-bullet',
            bulletActiveClass: 'my-bullet-active'
          }

        },
      }
    },

    components: {
      Swiper,
      SwiperSlide
    },

    mounted() {
      this.homeTime = homeTime
      this.homeTimeMobile = homeTimeMobile
      this.homeTimeM1 = homeTimeMobile[0]
      this.homeTimeM2 = homeTimeMobile[1]
      this.homeTimeM3 = homeTimeMobile[2]
      this.homeTimeM4 =homeTimeMobile[3]
      this.homeTimeM5 =homeTimeMobile[4]
    },

    watch: {
      currentIndex(val) {
      }
    },

    methods: {
      swiperChange(e) {
        this.activeIndex = e.activeIndex
      },
      debounceFirefox(e) {
        console.log('debounce-----------------debounce------------', e)

        var testDiv = document.getElementById('scrollBox');
        var divScrollTop = testDiv.scrollTop;
        var divClientHeight = testDiv.clientHeight;
        var divScrollHeight = testDiv.scrollHeight;
        console.log('debounce-----------------divScrollTop------------', divScrollTop)
        console.log('debounce-----------------divClientHeight------------', divClientHeight)
        console.log('debounce-----------------divScrollHeight------------', divScrollHeight)
        if (divScrollTop + divClientHeight >= divScrollHeight) {
          console.log('到底部了');
          this.$emit('scrollListener', '1')
        }
        if (divScrollTop == 0) {
          console.log('到顶部了');
          this.$emit('scrollListener', '1')
        }
      },
      debounce(e) {
        console.log('debounce-----------------debounce------------', e)

        var testDiv = document.getElementById('scrollBox');
        var divScrollTop = testDiv.scrollTop;
        var divClientHeight = testDiv.clientHeight;
        var divScrollHeight = testDiv.scrollHeight;
        if (divScrollTop + divClientHeight >= divScrollHeight && e.wheelDelta < 0) {
          console.log('到底部了');
          this.$emit('scrollListener', '1')
        }
        if (divScrollTop == 0 && e.wheelDelta > 0) {
          console.log('到顶部了');
          this.$emit('scrollListener', '1')
        }
        // document.getElementById('scrollBox').scrollTop = 150 * 10;
        // document.getElementById('scrollBox').scrollLeft = 150 * 10;
      },
      // divScroll() {
      //   console.log('1111111111111111---divScroll1')
      //   var testDiv = document.getElementById('scrollBox');
      //   var divScrollTop = testDiv.scrollTop;
      //   var divClientHeight = testDiv.clientHeight;
      //   var divScrollHeight = testDiv.scrollHeight;
      //   if (divScrollTop + divClientHeight >= divScrollHeight) {
      //     console.log('到底部了');
      //     this.$emit('scrollListener', '1')
      //   }
      //   if (divScrollTop == 0) {
      //     console.log('到顶部了');
      //     this.$emit('scrollListener', '1')
      //   }
      // },
      moreClick() {
        // window.location.href = 'https://mp.weixin.qq.com/s/b2GNf8DrOaWmS8DsEmMS9Q'
        window.open('https://mp.weixin.qq.com/s/b2GNf8DrOaWmS8DsEmMS9Q', '_blank');
      },
      moreEnter(e) {
        this.isHover = true
        console.log('222222222222222222222')
        // console.log('111111111111111111', this.$refs.more.$el)
        // this.$refs.more.$el.style.cssText = '-webkit-animation: fadeIn 0.3s linear 1;animation: fadeIn 0.3s linear 1;animation-fill-mode: forwards;';
        // this.$refs.moreTest.$el.style.cssText = 'color: #fff;'
      },
      moreLeave(e) {
        this.isHover = false
        console.log('222222222222222222222')
        // this.$refs.more.$el.style.cssText = 'width: 230px;height: 51px;color: #FFFFFF;';
      },
    },

  }
</script>

<style scoped>

  .left {
    position: absolute;
    top: calc(50% - 51px);
    left: 0;
    transform: translate(0, -50%);
    padding-left: 7.71vw;
  }

  .title {
    width: 260px;
    font-size: 60px;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: 800;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    left: 50%;
    margin-left: -130px;
    top: 0;
    z-index: 10;
  }

  .title-line-box {
    width: 245px;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine {
    width: 100%;
    height: 26px;
    background: #FFCCC0;
  }

  .titleLine-animation {
    width: 100%;
    height: 26px;
    background: #FFFFFF;
    position: absolute;
    top: 0;
    left: 0;
  }

  .content {
    max-width: 500px;
    min-width: 240px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 30px;
    margin-top: 60px;
  }

  .btn-more {
    width: 230px;
    height: 51px;
    color: #FFFFFF;
    z-index: 500;
    /*overflow: hidden;*/
  }

  .btn-more-box {
    width: 230px;
    height: 51px;
    margin-top: 60px;
    border: 1px solid #000000;
    color: #000000;
    position: absolute;
    top: 56%;
    left: 7.71vw;
    cursor: pointer;
    z-index: 500;
  }

  .btn-more-text {
    width: 230px;
    height: 51px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }


  .btn-more:after {
  }

  .btn-more-hover {
    width: 230px;
    background: #000000;
    border: 1px solid #000000;
    -webkit-animation: fadeIn 0.3s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: fadeIn 0.3s linear 1;
    animation-fill-mode: forwards;
  }

  .titleLine-animation-index {
    -webkit-animation: spin 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spin 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }

  .test-scroll {
    width: 100%;
    height: 70%;;
    min-height: 620px;
    overflow: scroll;
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(0, 20%);
    /*margin-top: -310px;*/
    display: flex;
    flex-direction: row-reverse; /*隐藏滚动条，当IE下溢出，仍然可以滚动*/
    -ms-overflow-style: none;
    /*火狐下隐藏滚动条*/
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;

  }

  -webkit-scrollbar {
    width: 0px;
  }

  .right {
    width: auto;
    height: auto;
    padding-top: 30px;
  }

  .cover {
    width: 222px;
    height: 222px;
  }

  .floating-img {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 33px;
    top: -20px;
    z-index: 100;
  }

  .time-box {
    width: 424px;
    height: 241px;
    margin-left: 40px;
    margin-right: 8vw;
    padding-left: 32px;
    background: #F6F6F6;
    position: relative;
  }

  .time-title {
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 32px;
    line-height: 40px;
  }

  .time-subtitle {
    font-size: 24px;
    font-family: DIN-Light, DIN;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.25);
    margin-top: 10px;
  }

  .time-content {
    width: 90%;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
    margin-top: 10px;
    text-align: justify;
  }

  /*定义动画*/
  @-webkit-keyframes spin { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0px);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(245px);
    }
  }

  @keyframes spin {
    from {
      transform: translateX(0px);
    }
    to {
      transform: translateX(245px);
    }
  }

  @-webkit-keyframes fadeIn { /*兼容性写法。spin是关键帧的动画名称*/
    from {
      width: 0px;
      /*transform: translateX(0px);*/
      background: #FFFFFF;
    }
    to {
      width: 100%;
      /*transform: translateX(240px);*/
      background: #000000;
    }
  }

  @keyframes fadeIn {
    from {
      width: 0px;
      /*transform: translateX(0px);*/
      background: #FFFFFF;
      border: 1px solid #000000;
    }
    to {
      width: 100%;
      /*transform: translateX(240px);*/
      background: #000000;
      border: 1px solid #000000;
    }
  }

  @media screen and (max-width: 1440px) {
    .cover {
      width: 188px;
      height: 188px;
    }

    .time-box {
      width: 359px;
      height: 224px;
      margin-left: 34px;
      margin-right: 5vw;
      padding-left: 27px;
      background: #F6F6F6;
      position: relative;
      /*overflow: hidden;*/
    }


    .time-title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 24px;
      line-height: 32px;
    }

    .time-subtitle {
      font-size: 20px;
      font-family: DIN-Light, DIN;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.25);
      margin-top: 10px;
    }

    .time-content {
      width: 90%;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
      margin-top: 10px;
      text-align: justify;
    }
  }



  @media screen and (max-width: 1300px) {


    .content {
      max-width: 350px;
      min-width: 240px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      line-height: 30px;
      margin-top: 60px;
    }

    .cover {
      width: 188px;
      height: 188px;
    }

    .time-box {
      width: 359px;
      height: 224px;
      margin-left: 34px;
      margin-right: 5vw;
      padding-left: 27px;
      background: #F6F6F6;
      position: relative;
      /*overflow: hidden;*/
    }


    .time-title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 24px;
      line-height: 32px;
    }

    .time-subtitle {
      font-size: 20px;
      font-family: DIN-Light, DIN;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.25);
      margin-top: 10px;
    }

    .time-content {
      width: 90%;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
      margin-top: 10px;
      text-align: justify;
    }
  }


  @media screen and (max-height: 800px) {

    .test-scroll {
      width: 100%;
      height: 70%;;
      min-height: 420px;
      overflow: scroll;
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(0, 20%);
      /*margin-top: -310px;*/
      display: flex;
      flex-direction: row-reverse;
    }

    .btn-more-box {
      width: 230px;
      height: 51px;
      margin-top: 60px;
      border: 1px solid #000000;
      color: #000000;
      position: absolute;
      top: 60%;
      left: 7.71vw;
      cursor: pointer;
      z-index: 500;
    }
  }


  /**********************************  移动端********************************************/

  .content-m {
    width: 6.54rem;
    font-size: 0.26rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 0.44rem;
  }

  .title-m {
    width: 100%;
    font-size: 0.4rem;
    font-family: SourceHanSerifCN-Heavy, SourceHanSerifCN;
    font-weight: bolder;
    color: rgba(0, 0, 0, 0.85);
    position: absolute;
    text-align: center;
    left: 0;
    top: 0;
    z-index: 10;
  }

  .title-line-box-m {
    width: 100%;
    position: absolute;
    bottom: 0px;
    left: 0;
  }

  .titleLine-m {
    width: 100%;
    height: 0.16rem;
    background: #FFCCC0;
  }

  .titleLine-animation-m {
    width: 100%;
    height: 0.16rem;
    background: #f0f2f5;
    position: absolute;
    top: 0;
    left: 0;
  }

  .titleLine-animation-index-m {
    -webkit-animation: spinm 0.8s linear 1; /*鼠标hover时，i图标旋转,infinite表示动画无限循环*/
    animation: spinm 0.8s linear 1;
    animation-fill-mode: forwards;
    /*background: #ff0000;*/
  }


  .btn-more-box-m {
    width: 2.02rem;
    height: 0.64rem;
    border-radius: 4px;
    border: 1px solid #000000;
    margin-top: 60px;
    font-size: 0.24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    cursor: pointer;
    z-index: 500;
  }

  .btn-more-text {
    width: 230px;
    height: 51px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 200;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }

  .home-item {
    width: 5.65rem;
    height: 2.92rem;
    background: #ffffff;
  }

  .cover-m {
    width: 1.92rem;
    height: 1.92rem;
    margin-left: 0.32rem;
    /*margin-top: 0.32rem;*/
    /*background: #f00;*/
  }

  .time-box-m {
    width: 68.56%;
    height: 2.32rem;
    background: #ffffff;
    position: relative;
    margin-left: 0.2rem;
  }


  .time-title-m {
    font-size: 0.32rem;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 0.2rem;
    line-height: 0.32rem;
  }

  .time-subtitle-m {
    font-size: 0.24rem;
    font-family: DIN-Light, DIN;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.25);
    margin-top: 0.1rem;
  }

  .time-content-m {
    width: 90%;
    font-size: 0.22rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 0.28rem;
    margin-top: 0.12rem;
    text-align: justify;
  }


  .floating-img-m {
    width: 0.44rem;
    height: 0.44rem;
    position: absolute;
    right: 0.30rem;
    top: -0.22rem;
    z-index: 100;
  }

  /*定义动画*/
  @-webkit-keyframes spinm { /*兼容性写法。spin是关键帧的动画名称*/
    from { /*动画起始状态*/
      -webkit-transform: translateX(0%);
    }
    to { /*动画结束状态*/
      -webkit-transform: translateX(100%);
    }
  }

  @keyframes spinm {
    from {
      -webkit-transform: translateX(0%);
    }
    to {
      -webkit-transform: translateX(100%);
    }
  }


  .swiper-container {
    transform: translateX(-2.2rem);
  }

  .point-default {
    width: 0.1rem;
    height: 0.1rem;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.05);
    margin-right: 0.08rem;
  }

  .point-select {
    width: 0.24rem;
    height: 0.1rem;
    background: rgba(0, 0, 0, 0.15);
    border-radius: 0.06rem;
    margin-right: 0.08rem;
  }

  .fontE4 {
    display: -webkit-box;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
  }


  /*  *************************************************************************************/


</style>



// WEBPACK FOOTER //
// src/page/home/components/HomeThird.vue